import { SeedingActivityPage } from './SeedingActivityPage';
import { SeedListPage } from './SeedListPage';
import { SeedListPromoPage } from './SeedListPromoPage';

export default {
  SeedingActivityPage,
  SeedListPage,
  SeedListPromoPage
};
